// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".large-text-section[data-v-3b7fd812]{background-color:var(--c-bg-color);box-shadow:0 0 3px 1px rgba(0,0,0,.1);padding-bottom:3rem;padding-top:3rem}.large-text-section .grid[data-v-3b7fd812]{max-width:700px}.large-text-section__text.large-text-section__text[data-v-3b7fd812]{color:var(--c-text-color);font-size:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
